<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,782.57v3.41l-8.54,8.27l5-0.43l-6.7,3.88l4.66,1.2l-6.87,1.63l4.38,1.59l-2.73,0.32h-2.81
	c-0.11-0.54-0.3-1.06-0.56-1.57c0.46-0.22,0.77-0.69,0.77-1.22c0-0.45-0.21-0.84-0.54-1.09c0.3-0.16,0.51-0.47,0.51-0.84
	c0-0.52-0.42-0.95-0.95-0.95c-0.52,0-0.95,0.42-0.95,0.95c0,0.23,0.08,0.45,0.22,0.61c-0.27,0.07-0.5,0.22-0.68,0.42
	c-0.32-0.3-0.67-0.57-1.04-0.82c0.13-0.21,0.2-0.45,0.2-0.71c0-0.76-0.62-1.38-1.38-1.38c-0.62,0-1.14,0.41-1.31,0.96
	c-0.23-0.06-0.46-0.11-0.69-0.15v-5.05l0.64-1.8l0.95,5.2l2.99-6.53l-0.12,4.38c-0.36,0.22-0.6,0.62-0.6,1.07
	c0,0.69,0.56,1.26,1.26,1.26s1.26-0.56,1.26-1.26c0-0.65-0.49-1.18-1.13-1.25l4.77-6.04l-0.98,4.63l7.93-8.68H10.5L10.5,782.57z
	 M0.43,793.75c0-0.45-0.36-0.81-0.81-0.81s-0.81,0.36-0.81,0.81c0,0.12,0.03,0.23,0.07,0.33c-0.7,0.01-1.26,0.58-1.26,1.27
	c0,0.7,0.57,1.27,1.27,1.27s1.27-0.57,1.27-1.27c0-0.32-0.12-0.61-0.31-0.83C0.19,794.42,0.43,794.11,0.43,793.75L0.43,793.75z
	 M-0.61,798.43c0-0.45-0.36-0.81-0.81-0.81c-0.45,0-0.81,0.36-0.81,0.81c0,0.45,0.36,0.81,0.81,0.81
	C-0.98,799.24-0.61,798.88-0.61,798.43L-0.61,798.43z"/>
</svg>

</template>